import { authFetch } from "../../../../authFetch";


export const getPackgeDetailsById = async (id) => {
    try {
        const response = await authFetch(`package/packages-by-packageid/${id}`);
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(error);
    }
};